import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=36102e77&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlurHashResponsivePicture: require('/codebuild/output/src3208117147/src/studio-frank/components/global/BlurHashResponsivePicture.vue').default,Footer: require('/codebuild/output/src3208117147/src/studio-frank/components/global/Footer.vue').default})
